/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as MainImport } from './routes/_main'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as MainWelcomeImport } from './routes/_main/welcome'
import { Route as MainUserDetailsImport } from './routes/_main/user-details'
import { Route as MainLivenessCheckImport } from './routes/_main/liveness-check'
import { Route as MainLinkWalletImport } from './routes/_main/link-wallet'
import { Route as MainGetWalletsImport } from './routes/_main/get-wallets'
import { Route as AuthLoginImport } from './routes/_auth/login'

// Create/Update Routes

const MainRoute = MainImport.update({
  id: '/_main',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const MainWelcomeRoute = MainWelcomeImport.update({
  path: '/welcome',
  getParentRoute: () => MainRoute,
} as any)

const MainUserDetailsRoute = MainUserDetailsImport.update({
  path: '/user-details',
  getParentRoute: () => MainRoute,
} as any)

const MainLivenessCheckRoute = MainLivenessCheckImport.update({
  path: '/liveness-check',
  getParentRoute: () => MainRoute,
} as any)

const MainLinkWalletRoute = MainLinkWalletImport.update({
  path: '/link-wallet',
  getParentRoute: () => MainRoute,
} as any)

const MainGetWalletsRoute = MainGetWalletsImport.update({
  path: '/get-wallets',
  getParentRoute: () => MainRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainImport
      parentRoute: typeof rootRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_main/get-wallets': {
      id: '/_main/get-wallets'
      path: '/get-wallets'
      fullPath: '/get-wallets'
      preLoaderRoute: typeof MainGetWalletsImport
      parentRoute: typeof MainImport
    }
    '/_main/link-wallet': {
      id: '/_main/link-wallet'
      path: '/link-wallet'
      fullPath: '/link-wallet'
      preLoaderRoute: typeof MainLinkWalletImport
      parentRoute: typeof MainImport
    }
    '/_main/liveness-check': {
      id: '/_main/liveness-check'
      path: '/liveness-check'
      fullPath: '/liveness-check'
      preLoaderRoute: typeof MainLivenessCheckImport
      parentRoute: typeof MainImport
    }
    '/_main/user-details': {
      id: '/_main/user-details'
      path: '/user-details'
      fullPath: '/user-details'
      preLoaderRoute: typeof MainUserDetailsImport
      parentRoute: typeof MainImport
    }
    '/_main/welcome': {
      id: '/_main/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof MainWelcomeImport
      parentRoute: typeof MainImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AuthRoute: AuthRoute.addChildren({ AuthLoginRoute }),
  MainRoute: MainRoute.addChildren({
    MainGetWalletsRoute,
    MainLinkWalletRoute,
    MainLivenessCheckRoute,
    MainUserDetailsRoute,
    MainWelcomeRoute,
  }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/_main"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login"
      ]
    },
    "/_main": {
      "filePath": "_main.tsx",
      "children": [
        "/_main/get-wallets",
        "/_main/link-wallet",
        "/_main/liveness-check",
        "/_main/user-details",
        "/_main/welcome"
      ]
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx",
      "parent": "/_auth"
    },
    "/_main/get-wallets": {
      "filePath": "_main/get-wallets.tsx",
      "parent": "/_main"
    },
    "/_main/link-wallet": {
      "filePath": "_main/link-wallet.tsx",
      "parent": "/_main"
    },
    "/_main/liveness-check": {
      "filePath": "_main/liveness-check.tsx",
      "parent": "/_main"
    },
    "/_main/user-details": {
      "filePath": "_main/user-details.tsx",
      "parent": "/_main"
    },
    "/_main/welcome": {
      "filePath": "_main/welcome.tsx",
      "parent": "/_main"
    }
  }
}
ROUTE_MANIFEST_END */
